import type { SVGProps } from 'react';
export const Paste = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M15.6 9.3V5.1c0-.77-.63-1.4-1.4-1.4h-2.1a.7.7 0 0 0-.7-.7H7.2a.7.7 0 0 0-.7.7H4.4c-.77 0-1.4.63-1.4 1.4v9.1c0 .77.63 1.4 1.4 1.4h4.9c0 .77.63 1.4 1.4 1.4h4.9c.77 0 1.4-.63 1.4-1.4v-4.9c0-.77-.63-1.4-1.4-1.4m-6.3 1.4v3.5H4.4V5.1h2.1v1.4h5.6V5.1h2.1v4.2h-3.5c-.77 0-1.4.63-1.4 1.4m1.4 4.9v-4.9h4.9v4.9z" />
  </svg>
);
